import { useRef } from "react";

export default function ImageUploaderImages({ handleDrop, handleFileSelect, images, deleteImage }) {
    const fileInputRef = useRef(null);

    const _handleDrop = (e) => {
        // e.preventDefault();
        // const file = e.dataTransfer.files[0];
        handleDrop(e);
    };

    const _handleFileSelect = (e) => {
        // const file = e.target.files[0];
        // Do something with the selected file
        handleFileSelect(e);
    };

    const _handleClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    return (
        <>
            <div
                className="border-2 border-dashed border-gray-400 p-10 text-center cursor-pointer"
                onClick={_handleClick}
                onDrop={_handleDrop}
                onDragOver={(e) => e.preventDefault()}
            >
                <p className="text-gray-600">Drag & Drop an image or click anywhere</p>
                <input
                    type="file"
                    className="hidden"
                    onChange={_handleFileSelect}
                    ref={fileInputRef}
                    id="fileInput"
                />
                <label
                    htmlFor="fileInput"
                    className="bg-blue-500 text-white px-4 py-2 rounded cursor-pointer mt-2 inline-block"
                >
                    Select File
                </label>
            </div>
            {/* Uploaded Images List */}
            <div className="mt-4">
                {images.map((image, index) => (
                    <div key={index} className="flex items-center justify-between p-2 border rounded mt-2">
                        <img src={image} alt="Uploaded" className="w-16 h-16 object-cover rounded" />
                        <button className="bg-red-500 text-white px-2 py-1 rounded" onClick={() => deleteImage(image)}>
                            Delete
                        </button>
                    </div>
                ))}
            </div>
        </>
    );
}
